// extracted by mini-css-extract-plugin
export default {"kdevSearch":"index__kdevSearch___PJWe5","kdevSearchIcon":"index__kdevSearchIcon___z8evz"};